import { render, staticRenderFns } from "./ImportMenu.vue?vue&type=template&id=1fa6fc04&"
import script from "./ImportMenu.vue?vue&type=script&lang=js&"
export * from "./ImportMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ImportMenu.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/menus/ImportMenu.vue
// module id = 1651
// module chunks = 1